import React, { useEffect, useState } from "react";
import axios from "axios";
import PriceCard from "./PriceCard";
const PriceCardSection = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/packages/get-all-package`,
        );
        setPackages(res.data.data || []);
      } catch (error) {
        console.error("Error fetching packages:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPackages();
  }, []);
  return (
    <section className=" md:py-10 py-6 mx-auto">
      <div className="md:px-10 px-6 flex flex-col flex-wrap xl:flex-row items-center gap-10">
        {loading ? (
          Array.from({ length: 3 }).map((_, i) => (
            <div
              key={i}
              className="relative min-h-[725px] shadow-sm xl:w-[35%] w-full rounded-3xl overflow-hidden animate-pulse"
            >
              <div className="h-[240px] bg-gray-300 w-full absolute top-0" />

              <div className="w-full md:py-10 py-6 md:px-10 px-6 flex flex-col justify-between gap-y-4 rounded-tl-3xl rounded-tr-3xl h-[calc(735px-28%)] bg-gray-100 absolute bottom-0 inset-x-0">
                <article className="flex flex-col gap-y-4 border-b border-gray-400 border-dashed pb-10">
                  <div className="h-8 bg-gray-300 w-2/3 rounded"></div>
                  <div className="h-4 bg-gray-300 w-full rounded"></div>
                  <div className="h-4 bg-gray-300 w-4/5 rounded"></div>
                </article>

                <div className="flex flex-col gap-y-4 pt-5">
                  {[...Array(5)].map((_, j) => (
                    <div key={j} className="flex gap-3 items-center">
                      <div className="h-5 w-5 bg-gray-300 rounded-full"></div>
                      <div className="h-4 w-3/4 bg-gray-300 rounded"></div>
                    </div>
                  ))}
                </div>

                <div className="w-full mt-5">
                  <div className="h-10 bg-gray-300 w-full rounded"></div>
                </div>
              </div>
            </div>
          ))
        ) : packages.length === 0 ? (
          <div className="relative mx-auto min-h-[400px] shadow-lg xl:w-[35%] w-full rounded-3xl overflow-hidden bg-gradient-to-br from-[#d1f5ff] via-[#b4ecf6] to-[#9fe3f2] flex items-center justify-center flex-col text-center p-10">
            <div className="bg-[#0BB6D9] text-white px-16 py-3 rounded-full text-sm uppercase tracking-widest mb-6">
              Coming Soon
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-3">
              Exciting Packages Ahead 🚀
            </h2>
            <p className="text-gray-600 max-w-md">
              We're working on something amazing for you! Stay tuned for our
              upcoming plans and offers.
            </p>
          </div>
        ) : (
          packages.map((pkg) => <PriceCard key={pkg._id} pkg={pkg} />)
        )}
      </div>
    </section>
  );
};

export default PriceCardSection;
